<template>
  <div class="wrapper">
    <div class="info head">
      <span class="label">{{$t('avatar')}}：</span>
      <div class="r">
        <div class="user-head">
          <input
            type="file"
            class="input-file"
            name="avatar"
            ref="avatarInput"
            @change="changeImage($event)"
            accept="image/gif, image/jpeg, image/jpg, image/png"
          >
          <img :src="userImage" alt v-loading="loadingShow">
          <div class="change">{{$t('change')}}{{$t('avatar')}}</div>
        </div>
      </div>
    </div>
    <div class="info">
      <span class="label">{{$t('nickname')}}：</span>
      <div class="r">
        <el-input type="text" class="input" v-model="userName"></el-input>
        <!-- <input type="text" placeholder="请输入昵称" v-model="userName" class="info-input"> -->
      </div>
    </div>
    <div class="info">
      <span class="label">{{$t('sex')}}：</span>
      <div class="r">
        <el-radio v-model="sex" :label="1">{{$t('man')}}</el-radio>
        <el-radio v-model="sex" :label="2">{{$t('woman')}}</el-radio>
      </div>
    </div>
    <div class="info">
      <span class="label">{{$t('birthday')}}：</span>
      <div class="r">
        <el-date-picker class="input" v-model="birthday" type="date" :placeholder="$t('optionDate')" value-format="yyyy-MM-dd"></el-date-picker>
      </div>
    </div>
    <div class="info">
      <span class="label">{{$t('area')}}：</span>
      <div class="r">
        <el-cascader class="input" clearable size="medium" :options="options" separator=" " 
          :placeholder="$t('pleaseSelect')" v-model="areaId"></el-cascader>
      </div>
    </div>
    <div class="info">
      <span class="label">{{$t('preference')}}：</span>
      <div class="r">
        <el-select class="input" clearable v-model="selectedPreferenceId" placeholder="请选择">
          <el-option
            v-for="item in getPreferenceList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="save" @click="saveInfo">{{$t('save')}}</div>
  </div>
</template>

<script>
import { apiBaseUrl } from "@/config/env.js";
import { get } from "core-js/core/dict";
export default {
  name: "UserInfo",
  components: {},
  props: {},
  data() {
    return {
      userInfo: {},
      userImage: "",
      userName: "",
      sex: 0,
      birthday: "",
      upLoadUrl: apiBaseUrl + "api.html",
      loadingShow: false,
      selectedPreferenceId: '',
      areaId: [],
      options: []
    };
  },
  watch: {},
  computed: {
    getPreferenceList() {
      let list = this.$store.state.config.user_preference
      return (list && list.length) ? list.slice(1) : [];
    }
  },
  methods: {
    saveInfo() {
      let data = {
        sex: this.sex,
        birthday: this.birthday,
        nickname: this.userName
      };
      if(this.selectedPreferenceId) {
        data.preference_ids = String(this.selectedPreferenceId);
      }
      if(this.areaId.length) {
        data.area_id = this.areaId[this.areaId.length-1];
      }
      this.$api.editInfo(data).then(res => {
        if (res.status) {
          this.$msg(res.msg);
          this.getUserInfo();
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    changeImage(e) {
      this.loadingShow = true;
      let file = e.target.files[0];
      var formdata = new FormData();
      formdata.append("upfile", file, file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          let data = {
            avatar: res.data.url
          };
          this.$api.changeAvatar(data).then(r => {
            if (r.status) {
              this.$msg(r.msg);
              this.userImage = r.data.avatar;
            } else {
              this.$msg(r.msg, "error");
            }
          });
        } else {
          this.$msg(res.msg, "error");
        }
        this.loadingShow = false;
      });
    },
    getUserInfo() {
      this.$api.userInfo().then(result => {
        if (result.status) {
          this.userInfo = result.data;
          this.userImage = this.userInfo.avatar;
          this.userName = this.userInfo.nickname;
          this.sex = this.userInfo.sex;
          this.birthday = this.userInfo.birthday;
          this.selectedPreferenceId = this.userInfo.preference_ids ? this.userInfo.preference_ids / 1 : '';
          this.areaId = [this.userInfo.province_id, this.userInfo.city_id, this.userInfo.district_id]
        }
      });
    },
    getTreeData(data){
      for(let i=0;i<data.length;i++){
        if('children' in data[i]) {
          if(!data[i].children || data[i].children.length<1){

            // console.log(data[i].children)
            // child若为空数组，则将child设为undefined
            data[i].children=undefined;
          }else {
            // child若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        }
      }
      return data;
    }
  },
  created() {},
  mounted() {
    this.getUserInfo();
    let addressList = this.$storage.get('areaList')
    this.options = this.getTreeData(addressList)
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.input {
  width: 200px;
}
.wrapper {
  .save {
    width: 120px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: $theme-color;
    color: #fff;
    margin-left: 80px;
    margin-top: 30px;
    cursor: pointer;
  }
  .info {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    &.head {
      align-items: flex-start;
      .label {
        padding-top: 10px;
      }
    }
    .label {
      display: inline-block;
      width: 60px;
      margin-right: 20px;
    }
    .r {
      .user-head {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        &:hover {
          .change {
            display: block;
          }
        }
        .input-file {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
          z-index: 99;
        }
        .change {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 70px;
          height: 18px;
          margin-left: -35px;
          line-height: 18px;
          text-align: center;
          margin-top: -8px;
          background: #757575;
          color: #fff;
          cursor: pointer;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info-input {
        width: 160px;
        height: 24px;
        line-height: 24px;
        border: 1px solid $border;
        padding-left: 12px;
      }
    }
  }
}
</style>